module.exports = __webpack_public_path__ + "img/NC_xionglei_2019.df8e68ea.png";